export default function HeroSection() {
  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero"
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat pt-16"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/b90f078cf90066d31dc5715f1c64017a/9c8230bfe4d007a487f59f298da6f2ca.png')`
      }}
    >
      <div className="absolute inset-0 bg-navy/50"></div>
      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-center lg:justify-start">
          <div className="space-y-8 text-center lg:text-left max-w-2xl">
            <h1 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
              売れる仕組みから考える<br />
              <span className="text-accent">Webサイト制作</span>
            </h1>
            <p className="text-xl text-gray-100 leading-relaxed">
              営業視点で導線を設計し<br />
              成果につながるサイトをスピーディーに構築します
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button 
                onClick={scrollToAbout}
                className="bg-cta hover:bg-cta-hover text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer shadow-lg"
              >
                制作の考え方を見る
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
